import { PermissionGroupApp } from 'data/__generated__';

export const PERMISSION_GROUP_APP_LABELS: Record<PermissionGroupApp, string> = {
    [PermissionGroupApp.Totadmin]: 'Totadmin',
    [PermissionGroupApp.Totops]: 'Totops',
    [PermissionGroupApp.Totmobile]: 'Totmobile',
    [PermissionGroupApp.Webapp]: 'Webapp',
};

/** Un slug est lu tel quel dans `users.permissions[].userGroup` : minuscules, chiffres et tirets (cf. API). */
export const toSlug = (label: string): string =>
    label
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
